import React from 'react'
import CodeSheetStatusBanner from './CodeSheetStatusBanner'

type UnselectableValuesBannerProps = {
  count: number
  // A rule affecting a flagged value (or the value itself) changed since the last save.
  needsRecheck: boolean
}

export function formatUnselectableValuesCount(count: number): string {
  return `${count} value${count === 1 ? '' : 's'} can no longer be selected.`
}

export const UNSELECTABLE_VALUES_FIX_INSTRUCTION = 'Fix the rules or remove each value before submitting.'
export const UNSELECTABLE_VALUES_RECHECK_INSTRUCTION = 'Save the codesheet to recheck.'

/**
 * Shown above the codesheet after a save finds values no configuration can include. It cannot be
 * dismissed; it goes away only when the next save finds nothing.
 */
export default function UnselectableValuesBanner({ count, needsRecheck }: UnselectableValuesBannerProps) {
  return (
    <CodeSheetStatusBanner testId="codesheet-unselectable-values-banner" variant="error">
      <span className="font-semibold">{formatUnselectableValuesCount(count)}</span>{' '}
      <span data-testid="codesheet-unselectable-values-instruction">
        {needsRecheck ? UNSELECTABLE_VALUES_RECHECK_INSTRUCTION : UNSELECTABLE_VALUES_FIX_INSTRUCTION}
      </span>
    </CodeSheetStatusBanner>
  )
}
